/**
 * @generated SignedSource<<181f97757f80e6f44567ba542541508f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuySharedResultContainer_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedItemTrackingProvider_viewer" | "SharedItemTile_viewer">;
  readonly " $fragmentType": "BuySharedResultContainer_viewer";
};
export type BuySharedResultContainer_viewer$key = {
  readonly " $data"?: BuySharedResultContainer_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuySharedResultContainer_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuySharedResultContainer_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedItemTile_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedItemTrackingProvider_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "b70f42c25a5f99a8fc51c01dcd288fbd";

export default node;
